const initialState = {
	findSystemGroups: null,
};

const systemGroupReducer = (state = initialState, action ) => {
	switch (action.type) {
		case "FIND_SYSTEM_GROUPS":
			state = {
				...state,
				findSystemGroups: action.payload
			};
			break;
		default :
			break;
	}
	return state;
};

export default systemGroupReducer;